import React from 'react';

export default function LotPriceInfo({ lot, auction }) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200 bg-gray-50">
        <h3 className="text-lg font-medium leading-6 text-gray-900">Price Information</h3>
      </div>
      <dl className="divide-y divide-gray-200">
        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Price Guide</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {lot.price_guide_value ? new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: auction.user_currency,
              minimumFractionDigits: Number.isInteger(lot.price_guide_value) ? 0 : 2
            }).format(lot.price_guide_value) : '—'}
          </dd>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Max Price</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {lot.max_price ? new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: auction.user_currency,
              minimumFractionDigits: Number.isInteger(lot.max_price) ? 0 : 2
            }).format(lot.max_price) : '—'}
          </dd>
        </div>
        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Opening Bid</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {lot.opening_bid ? new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: auction.auction_house_currency,
              minimumFractionDigits: Number.isInteger(lot.opening_bid) ? 0 : 2
            }).format(lot.opening_bid) : '—'}
          </dd>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Hammer Price</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {lot.winning_bid ? new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: auction.auction_house_currency,
              minimumFractionDigits: Number.isInteger(lot.winning_bid) ? 0 : 2
            }).format(lot.winning_bid) : '—'}
          </dd>
        </div>
      </dl>
    </div>
  );
}
